import * as React from 'react'
import { SVGProps } from 'react'
const SvgCheckDecagramOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width={39} height={36} viewBox="0 0 39 36" fill="none" {...props}>
    <path
      d="m13.633 36-3.283-5.487-6.234-1.355.608-6.365L.5 18l4.224-4.793-.608-6.365 6.234-1.355L13.634 0 19.5 2.47 25.366 0l3.284 5.487 6.234 1.355-.608 6.365L38.5 18l-4.224 4.793.608 6.365-6.234 1.355L25.366 36 19.5 33.53 13.633 36Zm1.175-3.495 4.692-1.972 4.748 1.972 2.611-4.379 5.06-1.15-.46-5.144L34.863 18l-3.404-3.888.46-5.144-5.06-1.094-2.667-4.38L19.5 5.467l-4.748-1.971-2.612 4.379-5.06 1.094.46 5.144L4.138 18l3.404 3.832-.46 5.2 5.06 1.095 2.667 4.378Zm2.76-8.66 9.758-9.677-1.938-1.978-7.82 7.754-3.956-3.867L11.674 18l5.894 5.846Z"
      fill="#1C1915"
    />
  </svg>
)
export default SvgCheckDecagramOutline
